import React from "react";
import { AiOutlineMenu, AiOutlineClose } from "react-icons/ai";
import { BR, LOGOSVG, US } from "../assets/image";

export function Navbar({ NAV_MENU, setIndex, index }: any) {
  const [open, setOpen] = React.useState(false);
  const [isScrolling, setIsScrolling] = React.useState(false);
  const [isScrollingDown, setIsScrollingDown] = React.useState(false);

  function NavItem({ id, name }: any) {
    return (
      <li>
        <a
          href={`#${id}`}
          className="flex items-center gap-2 font-bold text-sm text-white"
          onClick={(e) => {
            e.preventDefault();
            handleScrollToDiv(id);
            setOpen(false);
          }}
        >
          {name}
        </a>
      </li>
    );
  }

  function NavItemMobile({ id, name }: any) {
    return (
      <li>
        <a
          href={`#${id}`}
          className="flex items-center gap-2 text-sm text-gray-600 ml-5"
          onClick={(e) => {
            e.preventDefault();
            handleScrollToDiv(id);
            setOpen(false);
          }}
        >
          {name}
        </a>
      </li>
    );
  }

  function handleOpen() {
    setOpen((cur) => !cur);
  }

  React.useEffect(() => {
    window.addEventListener(
      "resize",
      () => window.innerWidth >= 960 && setOpen(false)
    );
  }, []);

  React.useEffect(() => {
    let lastScrollY = window.scrollY;
    function handleScroll() {
      if (window.scrollY > 0) {
        setIsScrolling(true);
      } else {
        setIsScrolling(false);
      }
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY) {
        setIsScrollingDown(true);
      } else if (currentScrollY < lastScrollY) {
        setIsScrollingDown(false);
      }
      lastScrollY = currentScrollY;
    }
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`lg:fixed w-full top-0 z-50 border-0 bg-[black]
      ${isScrolling ? "lg:bg-[black]" : "lg:bg-[transparent]"}
      ${isScrollingDown ? "lg:invisible" : "visible"}
      `}
    >
      <div
        className="mx-auto w-[70%] flex items-center justify-between py-10 align-middle
"
      >
        <img
          src={LOGOSVG}
          className="lg:w-2/12 w-4/12 object-cover h-full rounded-lg"
          alt=""
        />
        <ul className="ml-10 hidden items-center gap-6 lg:flex text-white">
          {NAV_MENU.map(({ id, name }: any) => (
            <NavItem id={id} name={name} />
          ))}

          <div className="ml-5 flex items-center justify-between">
            {index === 0 ? (
              <img className="w-4" src={BR} alt="Bandeira dos Estados Unidos" />
            ) : (
              <img className="w-4" src={US} alt="Bandeira dos Estados Unidos" />
            )}
            <select
              className="bg-transparent p-2 px-2 text-white"
              value={index}
              onChange={(e) => setIndex(Number(e.target.value))}
            >
              <option className="text-[#303133]" value={0}>
                Português
              </option>
              <option className="text-[#303133]" value={1}>
                English
              </option>
            </select>
          </div>

          <a
            href="https://portal.dmhealth.com.br/auth/login"
            target="_blank"
            className="ml-2 bg-[#e04f39] hover:[#e68475] text-white font-normal py-2 px-5 rounded-full "
            rel="noreferrer"
          >
            LOGIN
          </a>
        </ul>
        <button onClick={handleOpen} className="ml-auto inline-block lg:hidden">
          {open ? (
            <AiOutlineClose color="white" strokeWidth={2} className="h-6 w-6" />
          ) : (
            <AiOutlineMenu color="white" strokeWidth={2} className="h-6 w-6" />
          )}
        </button>
      </div>
      <div
        className={`bg-white rounded-lg py-4 mt-3 border-t border-gray-200 m-auto ${
          open ? "block" : "hidden"
        }`}
      >
        <ul className="flex flex-col gap-4">
          {NAV_MENU.map(({ id, name }: any) => (
            <NavItemMobile id={id} name={name} />
          ))}
        </ul>
      </div>
    </nav>
  );
}

export const handleScrollToDiv = (id: string) => {
  const div = document.getElementById(id);
  div?.scrollIntoView({ block: "start", behavior: "smooth" });
};

export default Navbar;
